// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PB_SERVICE_LIST_SHOW_NEW_SEARCH,
} from './constants';

export function showNewSearch(data) {
  return {
    type: PB_SERVICE_LIST_SHOW_NEW_SEARCH,
    data:data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PB_SERVICE_LIST_SHOW_NEW_SEARCH:
      return {
        ...state,
        showNewSearch:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/redux/showNewSearch.js